var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoriaDeselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 280.69 242.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6e38a;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #585a8a;\n      }\n\n      .cls-4 {\n        fill: #eb4548;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-6 {\n        fill: #8486c0;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.15,
    y: 0,
    width: 280.54,
    height: 242.62
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raccolta"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.85,199.95h138.19c-5.53-48.87-3.8-98.58,5.15-146.95H28.73c8.41,48.46,10.83,97.92,7.16,146.95h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,228.59l3.74-22.66,190.16-6.79,2.04,22.47L0,228.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.08,43.73l.66-23.85,199.02-6.82.66,22.5L3.08,43.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.71,35.31l-2.17,2.51-151.91,4.68c3.68,19.04,6.35,38.28,8.14,57.57,1.32-.41,2.61-.79,3.93-1.23,14.2-4.62,28.47-8.89,42.86-12.85,28.75-7.95,57.88-14.61,87.2-19.96,2.8-.5,5.59-.94,8.39-1.41,1.57-9.84,3.46-19.58,5.63-29.29h-2.08v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.57,203.83c-1.23-10.28-2.17-20.58-2.77-30.92-25.33,1.45-50.63,3.08-75.93,4.97-19.67,1.48-39.37,3.11-59.02,4.87-.34,7.32-.78,14.61-1.38,21.9l1.82-2.04,121.43,2.92c5.28-.53,10.59-1.1,15.87-1.7h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.7,242.72c-5.9-11.04-2.74-42.58,4.1-50.52l150.34-2.11c9.18,16.65,10.76,33.59,2.68,50.81l-157.12,1.86v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.35,58.84c-8.14-4.31-10.69-14.55-12.41-23.57-1-5.25-2.01-10.59-1.63-15.9.38-5.31,2.36-10.78,6.44-14.24L182.99.32c7.7,7.42,7.17,18.13,6.88,28.82-.25,9.81-1.63,20.52-8.7,27.31l-152.82,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.11,88.86c18.7,0,37.31-6.1,52.42-17.13-15.33-11.82-36.01-15.27-55.15-12.38-19.14,2.89-36.99,11.56-53.3,22-19.42,12.41-37.11,27.53-52.51,44.69-3.17,3.55-21.31,21.53-19.86,26.68-4.49,4.21-8.95,8.45-13.45,12.67,1.89.09,3.81.19,5.69.25,4.18-3.83,8.3-7.73,12.35-11.69,6.6-1.92,17.91-10.69,20.49-12.16,9.49-5.47,20.4-7.83,30.95-10.75,14.42-3.99,28.5-9.18,42.08-15.46-9.4-4.53-20.46-5.5-30.51-2.64,11.56-4.87,24.54-4.4,37.02-5.69,12.48-1.32,25.89-5.25,32.81-15.71-8.33-.25-16.62-.47-24.95-.72,4.87-2.29,10.53-1.85,15.93-1.85v-.09Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriaDeselected);
export default __webpack_public_path__ + "static/media/storiaDeselected.2d43153ecc89421f7a7bd8dc3c5a4db7.svg";
export { ForwardRef as ReactComponent };